var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuHandleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 379,
    viewBox: "0 0 123 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M66.5332 293.551L71.9598 309.391C71.9598 309.391 73.3198 313.711 71.0798 318.204L83.453 332.497L81.8264 313.031L66.5332 293.564V293.551Z",
    fill: "url(#paint0_linear_318_2420)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9866 38.5538C75.8267 69.3935 62.2669 93.7265 62.2669 93.7265C59.1602 100.553 54.9203 109.74 54.9203 109.74C53.1203 113.633 50.0137 121.833 50.0137 121.833C58.9202 112.006 64.6935 103.406 71.4935 94.5132C84.64 77.3267 93.5999 47.0337 97.9732 29.4072C100.04 21.1273 101.08 15.634 101.08 15.634C108.693 11.9407 112.746 9.66075 113.226 9.38075C113.933 9.03409 114.64 8.71409 115.346 8.39409C112.226 4.28747 108.426 1.23417 108.426 1.23417C96.6399 -0.53915 91.7999 5.91412 91.7999 5.91412C91.0932 11.8474 90.1066 17.5807 88.9333 23.0606C87.7733 28.4606 86.4266 33.6338 84.9733 38.5404L84.9866 38.5538Z",
    fill: "url(#paint1_linear_318_2420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9336 109.74C54.9336 109.74 61.5735 95.0335 62.0135 94.3001C62.0135 94.3001 75.8267 69.3937 84.9866 38.5541C86.4399 33.6474 87.7866 28.4742 88.9466 23.0742C88.9466 23.0742 91.3066 64.2471 54.9336 109.74Z",
    fill: "url(#paint2_linear_318_2420)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9322 31.8055C98.9322 31.8055 97.5189 33.2588 93.2656 46.5387C93.2656 46.5387 94.719 27.9789 99.5456 13.1257C99.5456 13.1257 104.586 3.69914 108.532 1.3125C109.145 1.81916 113.945 5.07246 121.039 15.2324C120.332 15.5524 118.172 17.259 117.465 17.6057C116.985 17.8723 109.812 23.0723 98.9189 31.8055H98.9322Z",
    fill: "url(#paint3_linear_318_2420)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M91.8125 5.91415C91.8125 5.91415 95.9991 0.340877 106.052 0.98087C101.772 6.84748 93.5991 8.24746 91.8125 5.91415Z",
    fill: "url(#paint4_linear_318_2420)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9332 31.8061L101.987 23.0729C106.053 17.6063 110.72 14.793 110.72 14.793C110.72 14.793 114.84 15.3796 118.8 16.7396L117.466 17.6063C107.866 23.9262 98.9199 31.8061 98.9199 31.8061H98.9332Z",
    fill: "url(#paint5_linear_318_2420)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M57.2003 113.406C57.2003 113.406 59.8002 106.873 61.6936 100.833L64.3735 89.793C63.9869 90.273 62.7469 93.1263 62.2669 93.7129C57.1869 103.873 54.2536 110.286 50.0137 121.819C50.0137 121.819 55.2003 115.646 57.1869 113.393L57.2003 113.406Z",
    fill: "url(#paint6_linear_318_2420)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5197 139.407C32.5197 139.407 18.1331 154.58 9.54657 189.513H0C0 189.513 2.25331 151.047 38.9996 118.207L32.5197 139.407Z",
    fill: "url(#paint7_linear_318_2420)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9866 340.482C75.8267 309.643 62.2669 285.309 62.2669 285.309C59.1602 278.483 54.9203 269.296 54.9203 269.296C53.1203 265.403 50.0137 257.203 50.0137 257.203C58.9202 267.03 64.6935 275.63 71.4935 284.523C84.64 301.709 93.5999 332.002 97.9732 349.629C100.04 357.909 101.08 363.402 101.08 363.402C108.693 367.095 112.746 369.375 113.226 369.655C113.933 370.002 114.64 370.322 115.346 370.642C112.226 374.749 108.426 377.802 108.426 377.802C96.6399 379.575 91.7999 373.122 91.7999 373.122C91.0932 367.189 90.1066 361.455 88.9333 355.975C87.7733 350.575 86.4266 345.402 84.9733 340.496L84.9866 340.482Z",
    fill: "url(#paint8_linear_318_2420)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9336 269.297C54.9336 269.297 61.5735 284.003 62.0135 284.737C62.0135 284.737 75.8267 309.643 84.9866 340.483C86.4399 345.389 87.7866 350.563 88.9466 355.963C88.9466 355.963 91.3066 314.79 54.9336 269.297Z",
    fill: "url(#paint9_linear_318_2420)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8656 346.136C97.8656 346.136 97.5189 345.776 93.2656 332.496C93.2656 332.496 94.719 351.056 99.5456 365.909C99.5456 365.909 104.586 375.336 108.532 377.722C109.145 377.216 119.252 368.202 122.079 364.482C121.372 364.162 116.759 360.802 116.052 360.456C115.572 360.189 106.905 354.603 97.8656 346.136Z",
    fill: "url(#paint10_linear_318_2420)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8125 373.123C91.8125 373.123 95.9991 378.696 106.052 378.056C101.772 372.19 93.5991 370.79 91.8125 373.123Z",
    fill: "url(#paint11_linear_318_2420)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8652 346.137L100.465 353.35C102.372 359.923 107.132 364.923 107.132 364.923C107.132 364.923 110.478 365.617 113.465 364.043L117.252 361.23C115.345 360.203 104.252 351.63 97.8652 346.15V346.137Z",
    fill: "url(#paint12_linear_318_2420)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M57.2003 265.632C57.2003 265.632 59.8002 272.165 61.6936 278.205L64.3735 289.245C63.9869 288.765 62.7469 285.912 62.2669 285.325C57.1869 275.165 54.2536 268.752 50.0137 257.219C50.0137 257.219 55.2003 263.392 57.1869 265.645L57.2003 265.632Z",
    fill: "url(#paint13_linear_318_2420)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5197 239.633C32.5197 239.633 18.1331 224.46 9.54657 189.527H0C0 189.527 2.25331 227.994 38.9996 260.833L32.5197 239.633Z",
    fill: "url(#paint14_linear_318_2420)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54656 189.511C17.6931 155.445 32.5197 139.405 32.5197 139.405L36.2263 127.285C9.02657 153.058 4.61328 189.511 4.61328 189.511C4.61328 189.511 9.02657 225.977 36.2263 251.737L32.5197 239.617C32.5197 239.617 17.6931 223.564 9.54656 189.511Z",
    fill: "url(#paint15_linear_318_2420)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M29.2266 235.418C29.2266 235.418 30.3465 242.325 30.1732 245.445L32.5199 254.631L38.9998 260.831L36.2265 251.751L32.5199 239.631L29.2266 235.418Z",
    fill: "url(#paint16_linear_318_2420)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M38.9998 118.207L36.2265 127.287L32.5199 139.407L29.2266 143.62V134.7L36.2265 120.767L38.9998 118.207Z",
    fill: "url(#paint17_linear_318_2420)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_2420",
    x1: 74.9864,
    y1: 185.965,
    x2: 74.9864,
    y2: 253.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_2420",
    x1: 41.0318,
    y1: 40.2554,
    x2: 96.5858,
    y2: 69.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_2420",
    x1: 98.0379,
    y1: 79.5423,
    x2: 48.7727,
    y2: 53.1709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_2420",
    x1: 109.596,
    y1: 27.7452,
    x2: 91.9635,
    y2: 18.3066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_2420",
    x1: 93.9398,
    y1: 0.0385374,
    x2: 108.54,
    y2: 7.85371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_2420",
    x1: 142.883,
    y1: 41.6467,
    x2: 124.721,
    y2: 31.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_2420",
    x1: 56.6908,
    y1: 104.714,
    x2: 60.9579,
    y2: 106.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_2420",
    x1: 15.2265,
    y1: 162.087,
    x2: 1.39999,
    y2: 189.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_2420",
    x1: 41.2604,
    y1: 338.623,
    x2: 96.8145,
    y2: 308.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_2420",
    x1: 98.2665,
    y1: 299.337,
    x2: 49.0013,
    y2: 325.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_2420",
    x1: 110.23,
    y1: 350.9,
    x2: 92.0683,
    y2: 360.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_2420",
    x1: 94.1621,
    y1: 378.829,
    x2: 108.774,
    y2: 371.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_2420",
    x1: 141.232,
    y1: 336.831,
    x2: 123.411,
    y2: 346.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_2420",
    x1: 56.9194,
    y1: 274.166,
    x2: 61.1865,
    y2: 271.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_2420",
    x1: -0.559995,
    y1: 239.767,
    x2: 18.8531,
    y2: 225.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_2420",
    x1: 61.346,
    y1: 207.218,
    x2: 9.57322,
    y2: 170.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_2420",
    x1: 34.1198,
    y1: 165.232,
    x2: 34.1198,
    y2: 209.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_2420",
    x1: 34.1198,
    y1: 48.0211,
    x2: 34.1198,
    y2: 92.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuHandleLeft);
export default __webpack_public_path__ + "static/media/quick-menu-handle-left.7b0e8ffc0d429e30c88905ec56871064.svg";
export { ForwardRef as ReactComponent };